import { NgModule } from '@angular/core';
import { DashboardComponent } from './dashboard/dashboard.component';
import { Route, RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { DxModule } from 'src/app/shared/dx.module';
import { MaterialModule } from 'src/app/shared/material.module';
import { OrdersCustomersByDateChartComponent } from './orders-customers-by-date-chart/orders-customers-by-date-chart.component';
import { OrdersCustomersByHourChartComponent } from './orders-customers-by-hour-chart/orders-customers-by-hour-chart.component';
import { OrdersCustomersByMunicipalityChartComponent } from './orders-customers-by-municipality-chart/orders-customers-by-municipality-chart.component';
import { TopCategoriesComponent } from './top-categories/top-categories.component';
import { TopProductsComponent } from './top-products/top-products.component';
import { TopCustomersComponent } from './top-customers/top-customers.component';
import { TopChartComponent } from './top-chart/top-chart.component';
import { DashboardFiltersComponent } from './dashboard-filters/dashboard-filters.component';
import { NotificationsModule } from '../../../shared/notifications/notifications.module';
import { OrdersByOrderStatusComponent } from './orders-by-order-status/orders-by-order-status.component';
import { OrdersByDeliveryStatusComponent } from './orders-by-delivery-status/orders-by-delivery-status.component';
import { B2bTopCategoriesComponent } from './b2b-top-categories/b2b-top-categories.component';
import { B2bTopProductsComponent } from './b2b-top-products/b2b-top-products.component';
import { SitemapComponent } from './sitemap/sitemap.component';

export const dashboardRoutes: Route[] = [
  {
    path: '',
    component: DashboardComponent
  },
  {
    path: ':type/:tab',
    component: DashboardComponent
  },
  {
    path: 'notifications',
    redirectTo: 'notifications/system'
  },
  {
    path: 'generate-sitemap',
    component: SitemapComponent
  }
]

@NgModule({
  declarations: [
    DashboardComponent,
    OrdersCustomersByDateChartComponent,
    OrdersCustomersByHourChartComponent,
    OrdersCustomersByMunicipalityChartComponent,
    TopCategoriesComponent,
    TopProductsComponent,
    TopCustomersComponent,
    TopChartComponent,
    DashboardFiltersComponent,
    OrdersByDeliveryStatusComponent,
    OrdersByOrderStatusComponent,
    B2bTopCategoriesComponent,
    B2bTopProductsComponent,
    SitemapComponent
  ],
  imports: [
    SharedModule,
    MaterialModule,
    DxModule,
    RouterModule.forChild(dashboardRoutes),
    NotificationsModule
  ]
})
export class DashboardModule { }
